var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeFechar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32216 1.16395C1.84286 0.587521 2.68708 0.587521 3.20778 1.16395L10.265 8.9765L17.3222 1.16395C17.8429 0.587521 18.6871 0.587521 19.2078 1.16395C19.7285 1.74038 19.7285 2.67496 19.2078 3.25139L12.1506 11.0639L19.2078 18.8765C19.7285 19.4529 19.7285 20.3875 19.2078 20.9639C18.6871 21.5404 17.8429 21.5404 17.3222 20.9639L10.265 13.1514L3.20778 20.9639C2.68708 21.5404 1.84286 21.5404 1.32216 20.9639C0.801466 20.3875 0.801466 19.4529 1.32216 18.8765L8.37936 11.0639L1.32216 3.25139C0.801466 2.67496 0.801466 1.74038 1.32216 1.16395Z",
    fill: "#3F3F55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeFechar);
export default __webpack_public_path__ + "static/media/icone-fechar.cd090b31a251c8fe93b5a61367392194.svg";
export { ForwardRef as ReactComponent };